import { Box } from "@mui/material";
import styled from "styled-components";

export const AttendantCardTopContainer = styled(Box as any)`
  padding-bottom: 4px;
  display: flex;

  #buttonsRight {
    display: flex;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 24px;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-left: 0px !important;
  margin-left: -16px;
  margin-bottom: 6px;
`;

export const RightContainer = styled.div`
  width: 60px;
  display: none;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ContainerIcon = styled.div`
  margin-left: 5px;
  margin-top: 15px;
  margin-bottom: 10px;
`;

export const IconArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
